<template>
    <div class="rule" style="width: 100%">
      <van-nav-bar
              title="拉新规则"
              left-text="返回"
              left-arrow
              @click-left="$goBack()"
      />
        <img :src="jobInfo.jobExInfo.ruleUrl" />
    </div>
</template>

<script>
    import mainAPI from '@/api/main'

    export default {
        data() {
            return {
                jobInfo:{
                    jobExInfo:{
                        bannerUrl:'',
                        logoUrl:'',
                        ruleUrl:'',
                        courseUrl:'',
                        bgColor:'',
                        videoUrl:''
                    }
                },
                query: {
                    id: this.$route.query.id,
                }
            }
        },
        created() {
            if(this.query.id){
                this.taskInfo()
            }
        },
        methods: {
            taskInfo() {
                this.$toast.loading({forbidClick:true})
                mainAPI.taskInfo(this.query.id,null,'y').then((result) => {
                    this.jobInfo = result.data
                    this.$toast.clear()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    img{
        width: 100%;
    }

</style>
